import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import HomePage from './Pages/Home';
import MainAboutPage from './Pages/About';
import ContactPage from './Pages/Contact';
import Items from './Pages/Items';
import Error404 from './Pages/404';
import { HelmetProvider } from 'react-helmet-async';
import ItmportItems from './Pages/importItems';

// Define routes
const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
  },
  {
    path: '/Home',
    element: <HomePage />,
  },
  {
    path: '/About',
    element: <MainAboutPage />,
  },
  {
    path: '/Contact',
    element: <ContactPage />,
  },
  {
    path: '/Items',
    element: <Items />,
  },
  {
    path: '/Itemsimport',
    element: <ItmportItems/>,
  },
  {
    path: '*',
    element: <Error404 />,
  },
]);

// Render your application
ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <RouterProvider router={router}>
        <App /> {/* Ensure your App component is wrapped with RouterProvider */}
      </RouterProvider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// Report Web Vitals (if applicable)
reportWebVitals();
